import { Location, NgTemplateOutlet } from '@angular/common';
import { booleanAttribute, Component, inject, input, TemplateRef } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ModalController } from '@ionic/angular';
import { IonButton, IonButtons, IonHeader, IonIcon, IonToolbar } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { arrowBackOutline, chevronDownOutline } from 'ionicons/icons';
import { FarmState } from '../../../core/services/states/farm.service';
import { SelectFarmComponent } from '../../../routes/dashboard/mobile/components/select-farm/select-farm.component';
import { I18nPipe } from '../../../shared/pipes/i18n.pipe';

@Component({
  selector: 'app-topnav',
  templateUrl: './topnav.component.html',
  styleUrls: ['./topnav.component.less'],
  imports: [NgTemplateOutlet, IonHeader, IonToolbar, IonButtons, IonButton, IonIcon, I18nPipe]
})
export class TopnavComponent {
  readonly titleI18n = input<string | null>(null);
  readonly enableBack = input(false, { transform: booleanAttribute });
  readonly enableSelectFarm = input(false, { transform: booleanAttribute });
  readonly leftSlotTpl = input<TemplateRef<unknown> | null>(null);
  readonly rightSlotTpl = input<TemplateRef<unknown> | null>(null);

  protected readonly farmState = inject(FarmState);
  private readonly location = inject(Location);
  private readonly modalController = inject(ModalController);
  private farmModalOpen = false;

  protected readonly selectedFarm = toSignal(this.farmState.get$(), { initialValue: this.farmState.get() });
  constructor() {
    addIcons({
      arrowBackOutline,
      chevronDownOutline
    });
  }

  protected resolvedTitleI18n(): string {
    return this.titleI18n() ?? '';
  }

  protected navigateBack(): void {
    this.location.back();
  }

  protected async openFarmModal(): Promise<void> {
    if (this.farmModalOpen) return;
    this.farmModalOpen = true;

    try {
      const top = await this.modalController.getTop();
      if (top) return;

      const modal = await this.modalController.create({
        component: SelectFarmComponent,
        cssClass: 'modal-size-50',
        initialBreakpoint: 1,
        breakpoints: [0, 1],
        handle: false
      });

      await modal.present();
      await modal.onDidDismiss();
    } finally {
      this.farmModalOpen = false;
    }
  }
}
